import {Box, Button, Paper, Stack, Typography} from '@mui/material';
import {HelpOutline as HelpOutlineIcon} from '@mui/icons-material';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useFirstDocumentGuide} from 'src/components/hooks/useFirstDocumentGuide';

export const FirstDocumentGuidePanel = () => {
  const {t} = useTranslation();
  const {visible, open, toggle, reviewTask} = useFirstDocumentGuide();

  if (!visible || !open) return null;

  return (
    <Paper component="section" aria-labelledby="quick-start-heading"
      variant="outlined" sx={{p: {xs: 2, sm: 3}, mb: 3}}>
      <Stack direction="row" justifyContent="space-between" alignItems="start" gap={2}>
        <Box>
          <Typography id="quick-start-heading" variant="h6">{t('quickStart.title')}</Typography>
          <Typography color="text.secondary" variant="body2">{t('quickStart.intro')}</Typography>
        </Box>
        <Button size="small" onClick={() => toggle(false)}>{t('quickStart.hide')}</Button>
      </Stack>
      <Stack component="ol" direction={{xs: 'column', md: 'row'}} gap={3}
        sx={{pl: 3, my: 3, '& > li': {flex: 1, pl: 0.5}}}>
        {['upload', 'review', 'export'].map((step) => (
          <Box component="li" key={step}>
            <Typography fontWeight={600}>{t(`quickStart.${step}.title`)}</Typography>
            <Typography variant="body2" color="text.secondary">
              {t(`quickStart.${step}.body`, {action: t('generateDoc')})}
            </Typography>
          </Box>
        ))}
      </Stack>
      <Stack direction={{xs: 'column', sm: 'row'}} gap={1}>
        <Button component={Link} to={reviewTask ? `/edit/${reviewTask.id}` : '/createTasks'} variant="contained">
          {t(reviewTask ? 'quickStart.reviewButton' : 'quickStart.uploadButton')}
        </Button>
        <Button href="mailto:info@anonify.nl?subject=Anonify%20onboarding">{t('quickStart.help')}</Button>
      </Stack>
    </Paper>
  );
};

/** Compact reopen control for the Quick Access header row; no full-width band. */
export const FirstDocumentGuideReopen = () => {
  const {t} = useTranslation();
  const {visible, open, toggle} = useFirstDocumentGuide();

  if (!visible || open) return null;

  return (
    <Button
      size="small"
      onClick={() => toggle(true)}
      startIcon={<HelpOutlineIcon sx={{fontSize: 16}} />}
      sx={{
        flexShrink: 0,
        px: 1,
        py: 0.25,
        minHeight: 28,
        fontWeight: 500,
        color: 'text.secondary',
        textTransform: 'none',
        '& .MuiButton-startIcon': {mr: 0.5},
      }}
    >
      {t('quickStart.open')}
    </Button>
  );
};

/** @deprecated Prefer FirstDocumentGuidePanel + FirstDocumentGuideReopen */
export const FirstDocumentGuide = FirstDocumentGuidePanel;
